import i18n from "~/i18n";

export const dateTypeOptions = [
	{ label: "전체", value: "1" },
	{ label: "3개월", value: "2" },
	{ label: "6개월", value: "3" },
	{ label: "12개월", value: "4" },
	{ label: "직접입력", value: "5" },
];

export const ROUND_BTN_STATUS = {
	오픈대기: ["check", "edit", "setting"],
	진행중: ["check", "setting", "result", "edit"],
	지원마감: ["check", "setting", "result", "edit"],
	심사중: ["check", "setting", "result", "close", "edit"],
	종료: ["check", "setting", "finalResult", "extra", "edit"],
};

export const ROUND_BTN_TEXT = {
	check: i18n.t("pages.round.RoundManage.List.button02"),
	edit: i18n.t("pages.round.RoundManage.List.button03"),
	setting: i18n.t("pages.round.RoundManage.List.button05"),
	result: i18n.t("pages.round.RoundManage.List.button04"),
	extra: i18n.t("pages.round.RoundManage.List.button07"),
	close: i18n.t("pages.round.RoundManage.List.status04"),
	finalResult: i18n.t("pages.round.RoundManage.List.button06"),
};
